<template>
    <div class="login_form">
      <img class="jcd_logo_login_form" src="../assets/bam_logo.png" alt="bam_logo" />
      <h1 class="platform_title_cn">巴士媒体受众测量系统</h1>
      <h1 class="platform_title_en">BUS AUDIENCE MEASUREMENT</h1>
      <div class="login_input">
        <el-row style="margin:10px;height:40px">
            <el-col :span="7" style="text-align: left;">
              <span style="font-size: 14px;color:#254A6E;font-weight: 600; vertical-align: sub;">{{$t('message.Email')}}:</span>
            </el-col>
            <el-col :span="16" :offset="1">
                <el-input  v-bind:placeholder="$t('message.Email')" v-model="input_email" clearable disabled>
        
                </el-input>
            </el-col>
        </el-row>
        <el-row style="margin:10px;height:40px">
            <el-col :span="7" style="text-align: left;">
                <span style="font-size: 14px;color:#254A6E;font-weight: 600; vertical-align: sub;">{{$t('message.new_password')}}</span>
            </el-col>
            <el-col :span="16" :offset="1">
              <el-input  show-password  v-bind:placeholder="$t('message.new_password')" v-model="input_pwd" clearable> <i slot="prefix" class="el-input__icon el-icon-lock"></i>
              </el-input>
             


            </el-col>
        </el-row>
        <el-row style="margin:10px;height:40px">
          <el-col :span="7" style="text-align: left;">
            <span style="font-size: 14px;color:#254A6E;font-weight: 600; vertical-align: sub;">{{$t('message.confirm_new_password')}}</span>
          </el-col>
          <el-col :span="16" :offset="1">
            <el-input show-password  v-bind:placeholder="$t('message.confirm_new_password')" v-model="input_pwd_again" clearable><i slot="prefix" class="el-input__icon el-icon-lock"></i>
            </el-input>
           </el-col>
        </el-row>
         
    
      </div>
      <div class="login_input">
      <button class="button_ok" @click="activate">{{ $t('message.activate') }}</button>
    </div>
      </div>
   
  </template>
  
  <script>
  import { Message } from 'element-ui';
  import _global from "./global.vue";
  import axios from "axios";
  import Verify from "./Verify.vue";
  
  export default {
    name: "activeAccount-form",
    props: ["lang"],
    data() {
      return {
        msg: "login",
        input_email: "",
        input_pwd: "",
        input_pwd_again:"",
        if_info: false,
        type_password:'password',
        p4LanSelected: true,
        lang_current: "cn",
        screenWidth: window.innerWidth,
        // isDirector:false,
        // isAll:false,
        // isNanjing:false,
        // isWuhan:false,
      };
    },
    components: {
      Verify,
    },
  
    created() {
      let api_url = _global.serverSrc + "/external_user/";
      let obj = {
        token: this.$route.query.Token 
       
      };
      axios
        .post(api_url, obj)
        .then((response) => {
          this.input_email = response.data.email
          if(response.data.active != 0){
            this.$alert(this.$t("message.account_has_been_activated"), this.$t("message.Warning"), {
              confirmButtonText: this.$t("message.Confirm"),
              callback: action => {
                  this.$router.push({
                    path: "/",
                });
              }
            });
     
          }
        })
     
    },
    mounted() {
      /*
      if (window.innerWidth >= 992) {
        const h = this.$createElement;
        this.$message({
          message: h('p', null, [
              h('span', { attrs: {id: 'notif'}, style: 'color: black; font-weight: bold; font-style: italic;'}, this.$t('message.Mobile_Notif'))
            ]),
          duration: 0,
          position: 'top-left',
          center: true,
        })
      }
      */
      this.$i18n.locale = this.lang_current;
      sessionStorage.setItem('lang', JSON.stringify(this.lang_current))
    },
    computed:{
        //验证码上线后修改
        ifVerify:function(){
            return false
        }
    },
  
    methods: {
      activate(){
        // check pwd and pwd_again is not null
        if (this.input_pwd == '' || this.input_pwd_again == '' ){
          this.$message({
            type: "error",
            message:this.$t("message.pwd_cannot_be_null"),
          });
        } else if (this.input_pwd != this.input_pwd_again){
          this.$message({
            type: "error",
            message: this.$t("message.pwd_inconsistent"),
            
          });
        } 
        else if(this.input_pwd.length < 12){
          this.$message({
            type: "error",
            message: this.$t("message.pwd_length_longer_than_12"),
            
          });

        } else if(!this.input_pwd.match("(?=.*[A-Z])(?=.*[a-z])(?=.*[0-9])")){
          this.$message({
            type: "error",
            message: this.$t("message.pwd_contains_character"),
          });
        }
        else {

          // check new password has been used before
          let api_url = _global.serverSrc + "/check_password_used/";
          let obj = {
            pwd:this.input_pwd,
            email: this.input_email
          }
          axios.post(api_url, obj).then((response)=>{
            if (response.data.result_code == true ){
              this.$message({
                type: "error",
                message:this.$t("message.pwd_not_repeated"),
              });
            } else {
              api_url = _global.serverSrc + "/update_external_user_pwd/";
         
              axios
                .post(api_url, obj)
                .then((response) => {
                  if (response.data.status_code == 'success'){
                    this.$message({
                    type: 'success',
                    message: this.$t('message.Data_is_saved')
                  });

                  axios
                  .post( _global.serverSrc + "/log_in/",  {
                      email: this.input_email,
                      password: this.input_pwd,
                    })
                    .then((response) => {
                      

                      let userAuthority = {
                        user_id : response.data[0].user_id,
                        is_jcd_domain : response.data[0].is_jcd_domain,
                        is_register_user : response.data[0].is_register_user,
                        is_national : response.data[0].is_national,
                        view_nanjing : response.data[0].view_nanjing,
                        view_wuhan : response.data[0].view_wuhan,
                        view_shenzhen : response.data[0].view_shenzhen,
                        view_chongqing : response.data[0].view_chongqing,
                        view_chengdu : response.data[0].view_chengdu,
                        inventory_nanjing : response.data[0].inventory_nanjing,
                        inventory_wuhan : response.data[0].inventory_wuhan,
                        view_statistics : response.data[0].view_statistics,
                        view_package_list : response.data[0].view_package_list,
                        is_admin : response.data[0].is_admin,
                        create_package : response.data[0].create_package,
                        create_crosscity : response.data[0].create_crosscity,
                        //update_report_status : response.data[0].update_report_status,
                        share_proposal : response.data[0].share_proposal,
                        bu : response.data[0].bu,
                        role : response.data[0].role,
                        discount : response.data[0].discount,
                      }
                      if (response.data[0].is_register_user) {
                        sessionStorage.setItem("User", JSON.stringify(this.input_email));
                        sessionStorage.setItem("UserAuthority", JSON.stringify(userAuthority));
                        sessionStorage.setItem("SlidingToken", JSON.stringify(response.data[0].sliding_token));
                        this.$router.push({
                          path: "/choose_city",
                        });
                      } else {
                        this.noticeWrongPwd();
                      }
                    })
                  }
                  
                })



            }


          })


          // change pwd
         


        }

      },
      noticeWrongPwd() {
      const h = this.$createElement;
      this.$notify({
        title: "Error",
        message: h(
          "i",
          {
            style: "color: teal",
          },
          "Please check your email and password."
        ),
      });
    },
    }
  };
  </script>
  
  <style lang="scss" scoped>
  
.icon-style {
  margin-top: 8px;
  font-size: 18px;
}
  
  .login_form{
      min-width: 300px;
      box-shadow: 0px 0px 12px 4px rgba(0, 0, 255, 0.2);
      position: absolute;
      border-radius: 25px;
      background-color: #fafafa;
      text-align: center;
      max-height: 600px;
      
      @media (max-width:767px) {
        width: 300px;
        top: 20%;
        margin-left: calc((100% - 300px)/2);
      }
      
      @media (min-width:768px) {
        top: 10%;
        right: 30%;
        width: 40%;
      }
      
      .jcd_logo_login_form {
          width:14em;
          margin-top: 6%;
          margin-bottom: 6%;
      }
      
      p,h1{
          //font-family: 'lato';
      }
  
      .platform_title_cn{
          color:#A4A4A4;
          font-size: 1.6em;
          cursor: default;
      }
      .platform_title_en{
          color:royalblue;
          font-size: 1em;
          cursor: default;
      }
  
      .login_input{
          width:80%;
          margin-top:5%;
          margin-bottom: 5%;
          margin-left:10%;
          margin-right:10%;
      }
      .button_ok {
          height: 45px;
          background-color: #888888;
          border: none;
          color: #fafafa;
          font-size: 18px;
          opacity: 0.9;
          width:100%;
          border-radius: 10px;
          cursor: pointer;
      }
      .button_ok:hover{
          background-color: #000000;
          transition: all .5s ease-out;
      }
      .slash::after{
          content: "|";
          color: #000000;
          margin: 0 5px;
      }
      .p4Lan{
          color: #969696;
          cursor: pointer;
      }
      .p4LanSelected{
          text-decoration: none;
          font-weight: 700;
          color: royalblue;
          cursor: pointer;
      }
      
      .p_lang{
          text-align: center;
          font-size: 20px;
          margin-top: 15%;
          margin-bottom: 1em;
      }
      
      .notif{
        position: relative;
        top: 2.5em;
        font-style: italic;
        background: #194475;
        color: white;
        border-radius: 5px;
        padding: 1px 0;
  
        .notif_icon{
          color: #A9B9D4;
          border-radius: 50%;
          background-color: white;
          font-size: 20px;
          vertical-align: text-bottom;
        }
      }
  }
  
  </style>